var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';

import { getStatuses } from '../../../services/core/home/home.helper';
import { homeModel } from '../../../models/core/home.model';
import * as modalActions from '../../../actions/modal.actions';
import { composeSpinner } from '../../../hoc/composeSpinner';

export class UserStatusModalContainerCore extends Component {
    constructor(...args) {
        var _temp;

        return _temp = super(...args), this.handleToggleModal = (type, data) => {
            this.props.modalActions.toggleModal({ type, data });
        }, this.handleSetHomeStatus = status => {
            if (!this.props.homeData.setHomeStatus.isLoading) {
                this.props.modalActions.closeModal();
                this.props.handleSetHomeStatus({ status });
            }
        }, _temp;
    }

    render() {
        return null;
    }
}

export const mapStateToPropsCore = (state, props) => {
    return {
        homeData: state.home[homeModel.MODEL_NAME],
        statuses: getStatuses(),
        modal: state.modal
    };
};

export const mapDispatchToPropsCore = apiSetHomeStatus => dispatch => {
    return {
        modalActions: bindActionCreators(_extends({}, modalActions), dispatch),
        handleSetHomeStatus: bindActionCreators(apiSetHomeStatus, dispatch)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/containers/pages/service/UserStatus.modal.container.js